import { METRICTYPE } from 'src/utils/entityDefinitions';
import { RatingsAndReviewMetric } from './ReviewMetricTypes';

export const RatingsAndReviewQueryParams = 'ReviewsSummaryMetric';
/**
 *  Key Metric Cards' first column
 */
export const keyMetricsRatings = [
  {
    label: 'weekly rating volume',
    id: RatingsAndReviewMetric.WEEKLY_RATING_VOLUME,
    metricType: METRICTYPE.VOLUME
  },

  {
    label: 'weekly rating',
    id: RatingsAndReviewMetric.WEEKLY_RATING,
    metricType: METRICTYPE.DECIMAL
  },

  {
    label: 'cumulative rating volume',
    id: RatingsAndReviewMetric.CUMULATIVE_RATING_VOLUME,
    metricType: METRICTYPE.VOLUME
  },

  {
    label: 'Cumulative rating',
    id: RatingsAndReviewMetric.CUMULATIVE_RATING,
    metricType: METRICTYPE.DECIMAL
  }
];

/**
 * Key Metric Cards' second column
 */
export const keyMetricsReviews = [
  {
    label: 'weekly review volume',
    id: RatingsAndReviewMetric.WEEKLY_REVIEW_VOLUME,
    metricType: METRICTYPE.VOLUME
  },
  { label: 'weekly review rating', id: RatingsAndReviewMetric.WEEKLY_REVIEW_RATING, metricType: METRICTYPE.DECIMAL },
  {
    label: 'cumulative review volume',
    id: RatingsAndReviewMetric.CUMULATIVE_REVIEW_VOLUME,
    metricType: METRICTYPE.VOLUME
  },
  {
    label: 'cumulative review rating',
    id: RatingsAndReviewMetric.CUMULATIVE_REVIEW_RATING,
    metricType: METRICTYPE.DECIMAL
  }
];

/**
 * Key Metric Cards' third column
 */
export const keyMetricsQuality = [
  { label: 'review quality score', id: RatingsAndReviewMetric.REVIEW_QUALITY_SCORE },
  { label: 'word count', id: RatingsAndReviewMetric.WORD_COUNT },
  { label: 'keyword count', id: RatingsAndReviewMetric.KEYWORD_COUNT },
  { label: 'writing quality', id: RatingsAndReviewMetric.KEYWORD_POPULARITY }
];

/**
 * Key Metric Cards' fourth column
 */
export const keyMetricsSentiments = [
  { label: 'weekly positive sentiment', id: RatingsAndReviewMetric.WEEKLY_POSITIVE_SENTIMENT },
  { label: 'weekly negative sentiment', id: RatingsAndReviewMetric.WEEKLY_NEGATIVE_SENTIMENT },
  { label: 'cumulative positive sentiment', id: RatingsAndReviewMetric.CUMULATIVE_POSITIVE_SENTIMENT },
  { label: 'cumulative negative sentiment', id: RatingsAndReviewMetric.CUMULATIVE_NEGATIVE_SENTIMENT }
];

export const lifetimeAggregationFields = [
  'weightedParentLifetimeRating',
  'parentLifetimeRatingVolume',
  'parentLifetimeRating',
  'weightedLifetimeReviewRating',
  'lifetimeReviewVolume',
  'lifetimeReviewRating',
  'parentLifetimeOneStarRatingCount',
  'parentLifetimeTwoStarsRatingCount',
  'parentLifetimeThreeStarsRatingCount',
  'parentLifetimeFourStarsRatingCount',
  'parentLifetimeFiveStarsRatingCount'
];

export const weeklyFields = [
  { name: 'weightedWeeklyReviewRating', canBeExported: false },
  { name: 'weeklyReviewVolume', canBeExported: true },
  { name: 'weeklyReviewRating', canBeExported: true },
  { name: 'weightedParentWeeklyRating', canBeExported: true },
  { name: 'parentWeeklyRatingVolume', canBeExported: true },
  { name: 'parentWeeklyRating', canBeExported: true },
  { name: 'parentWeeklyOneStarRatingCount', canBeExported: true },
  { name: 'parentWeeklyTwoStarsRatingCount', canBeExported: true },
  { name: 'parentWeeklyThreeStarsRatingCount', canBeExported: true },
  { name: 'parentWeeklyFourStarsRatingCount', canBeExported: true },
  { name: 'parentWeeklyFiveStarsRatingCount', canBeExported: true },
  { name: 'weeklyOneStarReviewVolume', canBeExported: true },
  { name: 'weeklyTwoStarsReviewVolume', canBeExported: true },
  { name: 'weeklyThreeStarsReviewVolume', canBeExported: true },
  { name: 'weeklyFourStarsReviewVolume', canBeExported: true },
  { name: 'weeklyFiveStarsReviewVolume', canBeExported: true },
  { name: 'weeklyPositiveSentimentReviewVolume', canBeExported: true },
  { name: 'weeklyNeutralSentimentReviewVolume', canBeExported: true },
  { name: 'weeklyNegativeSentimentReviewVolume', canBeExported: true }
];
